<template>
    <div class="course-details__wrap">
        <div class="course-base-info">
            <h2 class="course-name">{{ courseBaseInfo.name || '--' }}</h2>
            <h3 class="class-name">{{ courseBaseInfo.classname || '--' }}</h3>
            <ul class="course-data">
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.totalstudentcount }}</div>
                    <div class="course-data-item__label">学员总数</div>
                </li>
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ `${courseBaseInfo.finishperiodcount}/${courseBaseInfo.periodcount}` }}</div>
                    <div class="course-data-item__label">课程进展</div>
                </li>
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.studystudentcount }}</div>
                    <div class="course-data-item__label">总学习人数</div>
                </li>
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.finishcoursecount }}</div>
                    <div class="course-data-item__label">完课人数</div>
                </li>
                <li class="course-data-item">
                    <div class="course-data-item__value">{{ courseBaseInfo.finishrate }}</div>
                    <div class="course-data-item__label">完课率</div>
                </li>
            </ul>
            <el-button @click="$router.go(-1)" class="btn-go-back" icon="el-icon-arrow-left">返回上级</el-button>
        </div>
        <el-tabs @tab-click="handleTabChange" v-model="activeTabName" >
            <el-tab-pane label="考试配置" name="testInfo">
                <Test :courseCode="code" @goTest="goTestList" :classCode="classCode" ref="testInfo" />
            </el-tab-pane>
            <el-tab-pane  label="课时信息" name="CourseDate">
                <CourseDate  :courseCode="code" :classCode="classCode" ref="CourseDate" />
            </el-tab-pane>
            <el-tab-pane  label="学员信息" name="StuInfo">
                <StuInfo :courseCode="code" :classCode="classCode" ref="StuInfo" />
            </el-tab-pane>
            <el-tab-pane  label="作业信息" name="WorkList">
                <WorkList :classCode="classCode" :type="true" :classCourseCode="code" ref="WorkList" />
            </el-tab-pane>
            <el-tab-pane  label="考试信息" name="TestList">
                <TestList :classCourseCode="code" :type="true" :classCode="classCode" ref="TestList" />
            </el-tab-pane>
            <el-tab-pane   label="课程排课"  name="seven">
                <ClassSchedule :finishperiodcount="courseBaseInfo.finishperiodcount" :className="courseBaseInfo.classname" :classCourseName="courseBaseInfo.name" ref="ClassSchedule" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import Test from './courseDetail/test.vue'
import CourseDate from './courseDetail/courseDate.vue'
import StuInfo from './courseDetail/stuInfo.vue'
import ClassSchedule from './courseDetail/classSchedule.vue'
import { getCourseTopInfo } from '@/api/measApi/studyManagement'
import WorkList from './classDetail/workList.vue'
import TestList from './classDetail/testList.vue'
export default {
    components: {
        Test,
        CourseDate,
        StuInfo,
        ClassSchedule,
        WorkList,
        TestList
    },
    data: () => ({
        activeTabName: 'testInfo',
        courseBaseInfo: {},
    }),
    computed: {
        // 课程code
        code() {
            return this.$route.query.code || ''
        },
        // 班级code
        classCode() {
            return this.$route.query.classCode || ''
        }
    },
    created() {
        this.$nextTick(() => {
            this.$refs.testInfo.init()
        })
        this.getCourseTopInfo()
    },
    methods: {
        handleTabChange(e) {
            console.log(e,'eeee')
            e.$children[0].init()
        },
        // 获取课程顶部信息
        async getCourseTopInfo() {
            const res = await getCourseTopInfo({ code: this.code })
            if (res.code === '000') {
                this.courseBaseInfo = res.data
            }
        },
        goTestList(row){
            this.activeTabName = 'TestList'
            this.$refs.TestList.init()
        }
    },
}
</script>
<style lang="scss" scoped>
.course-details__wrap {
    padding: 0 0 20px;
}
// ::v-deep .el-dialog .el-dialog__body {
//     height: calc(100% - 51px) !important;
// }
.course-base-info {
    position: relative;
    padding: 20px;
    border-radius: 4px;
    background-color: #f6f7fb;

    >.btn-go-back {
        position: absolute;
        right: 20px;
        top: 20px;
    }
}
.course-name {
    font-size: 16px;
    color: #333;
}
.class-name {
    margin-top: 6px;
    font-size: 12px;
    line-height: 17px;
    color: #333;
}
.course-data {
    margin-top: 27px;
    display: flex;
    flex-wrap: wrap;
}
.course-data-item {
    flex-shrink: 0;
}
.course-data-item:not(:last-of-type) {
    margin-right: 60px;
    @media screen and (max-width: 850px) {
        margin-right: 20px;
    }
}
.course-data-item > div {
    text-align: center;
}
.course-data-item__value {
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    color: #333;
    font-weight: 600;
}
.course-data-item__label {
    margin-top: 8px;
    font-size: 12px;
    line-height: 17px;
    color: #666;
}
::v-deep .el-tabs {
    .el-tabs__item {
        padding: 0 20px !important;
        &.is-active {
            color: #4d5560 !important;
        }
        &:hover {
            color: #4d5560;
        }
        .el-tabs__nav-wrap::after {
            background-color: #f6f7fb;
        }
    }
}
</style>
